<template>
  <div style="background-color: #fff">
    <printing-a-4
      v-if="printingType === true && type == 'saleInvoice'"
      :invoiceDetails="invoiceDetails"
      :totalMainQty="totalMainQty"
      :totalSubQty="totalSubQty"
      :title="title"
      :invoiceType="invoiceType"
      :img="img"
    />
    <printing-normal
      v-if="printingType === false && type == 'saleInvoice'"
      :invoiceDetails="invoiceDetails"
      :totalMainQty="totalMainQty"
      :totalSubQty="totalSubQty"
      :title="title"
      :invoiceType="invoiceType"
      :img="img"
    />
    <printing
      v-if="type == 'productsReport'"
      :report="invoiceDetails"
      :searchKey="searchKey"
      :img="img"
    />
    <printing-customers-report
      v-if="type == 'CustomersReport'"
      :report="invoiceDetails"
      :customer="customer"
      :dateRange="dateRange"
      :img="img"
    />
    <printing-out-stock-report
      v-if="type == 'productsOutStockReport'"
      :report="invoiceDetails"
      :searchKey="searchKey"
      :img="img"
    />
    <printing-damaged-report
      v-if="type == 'productDamagedReport'"
      :report="invoiceDetails"
      :searchKey="searchKey"
      :img="img"
    />
    <printing-all-reports
      v-if="type == 'allReports'"
      :report="invoiceDetails"
      :title="title"
      :img="img"
    />
    <printing-customer-report-all
      v-if="type == 'CustomersReportAll'"
      :report="invoiceDetails"
      :customer="customer"
      :dateRange="dateRange"
      :img="img"
    />
    <printing-profites-report-all
      v-if="type == 'Profites'"
      :report="invoiceDetails"
      :dateRange="dateRange"
      :title="title"
      :img="img"
    />
    <printing-expenses
      v-if="type == 'Expenses'"
      :report="invoiceDetails"
      :dateRange="dateRange"
      :title="title"
      :img="img"
    />
    <printing-safe-report
      v-if="type == 'Safe'"
      :report="invoiceDetails"
      :dateRange="dateRange"
      :title="title"
      :img="img"
    />
    <printing-taslim-report
      v-if="type == 'TaslimReport'"
      :report="invoiceDetails"
      :dateRange="dateRange"
      :title="title"
      :img="img"
    />
    <printing-product-movement
      v-if="type == 'ProductMovement'"
      :report="invoiceDetails"
      :dateRange="dateRange"
      :title="title"
      :img="img"
    />
    <printing-customer-traffic
      v-if="type == 'CustomerTraffic'"
      :report="invoiceDetails"
      :customer="customer"
      :img="img"
    />
  </div>
</template>

<script>
// import { ipcRenderer } from "electron";

import PrintingA4 from "./PrintingA4.vue";
import PrintingNormal from "./PrintingNormal.vue";
import Printing from "./PrintingReport.vue";
import PrintingCustomersReport from "./PrintingCustomersReport.vue";
import PrintingOutStockReport from "./PrintingOutStockReport.vue";
import PrintingDamagedReport from "./PrintingDamagedReport.vue";
import PrintingAllReports from "./PrintingAllReports.vue";
import PrintingCustomerReportAll from "./PrintingCustomersRepotsAll.vue";
import PrintingProfitesReportAll from "./PrintingProfitesReportAll.vue";
import PrintingExpenses from "./PrintingExpenses.vue";
import PrintingSafeReport from "./PrintingSafeReport.vue";
import PrintingTaslimReport from "./PritingTaslimReport.vue";
import PrintingProductMovement from "./PrintingProductMovement.vue";
import PrintingCustomerTraffic from "./PrintingCustomerTraffic.vue";
// window.ipcRenderer = ipcRenderer;

export default {
  components: {
    PrintingCustomerReportAll,
    PrintingA4,
    PrintingNormal,
    Printing,
    PrintingCustomersReport,
    PrintingOutStockReport,
    PrintingDamagedReport,
    PrintingAllReports,
    PrintingProfitesReportAll,
    PrintingExpenses,
    PrintingSafeReport,
    PrintingTaslimReport,
    PrintingProductMovement,
    PrintingCustomerTraffic,
  },
  data: () => ({
    type: null,
    invoiceDetails: null,
    printingType: true,
    totalMainQty: 0,
    totalSubQty: 0,
    searchKey: "",
    customer: {},
    dateRange: null,
    title: "",
    invoiceType: "",
    img: "",
  }),
  // created() {
  //   ipcRenderer.on("PrintingNow", (e, data) => {
  //     if (data.type == "saleInvoice") {
  //       // alert("fff")
  //       this.totalSubQty = 0;
  //       this.totalMainQty = 0;
  //       this.printingType = JSON.parse(localStorage.getItem("printingType"));
  //       if (data.invoiceType === "sales") {
  //         data.data.products.map((item) => {
  //           if (Number(item.pivot.unit_type) === 1) {
  //             this.totalMainQty +=
  //               Number(item.pivot.qty) - Number(item.pivot.returned_qty);
  //           } else {
  //             this.totalSubQty +=
  //               Number(item.pivot.qty) - Number(item.pivot.returned_qty);
  //           }
  //         });
  //       } else {
  //         data.data.products.map((item) => {
  //           if (Number(item.pivot.unit_type) === 1) {
  //             this.totalMainQty += Number(item.pivot.qty);
  //           } else {
  //             this.totalSubQty += Number(item.pivot.qty);
  //           }
  //         });
  //       }
  //     }
  //     this.invoiceDetails = data.data;
  //     this.type = data.type;
  //     this.customer = data.customer;
  //     this.searchKey = data.searchKey;
  //     this.dateRange = data.dateRange;
  //     this.title = data.title;
  //     this.invoiceType = data.invoiceType;
  //     this.img = data.img;
  //     ipcRenderer.send("printTheComponent");
  //   });
  // },
};
</script>
